import { Form, Formik } from 'formik'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import styled from 'styled-components'
import * as Yup from 'yup'
import '@/utils/validation'
import { Box, Button, Stack, Text, IconArrowLeft, Dialog } from '@machobear/design-system'
import { breakpoints } from '@machobear/design-system/css'
import { PhoneInput } from '@/components/form'
import { colors } from '@/styles'

import useMediaQuery from '@/hooks/use-media-query'

const StyledForm = styled(Form)`
  width: 100%;
`

const Phone = styled(PhoneInput)`
  background-color: ${colors.white};
`

const validationSchema = Yup.object().shape({
  phone: Yup.string().phone().required()
})

const ShareByPhone = ({ listingId, open, onClose, showMainModal }) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const isMobile = useMediaQuery(`(max-width: ${breakpoints.tablet}px)`)

  const handleSend = async (values, { setSubmitting }) => {
    await dispatch.listing.sendTextInvite({
      listingId: listingId,
      phoneNumber: values.phone
    })
    setSubmitting(false)
    onClose()
  }

  const handleBack = async () => {
    onClose()
    showMainModal()
  }

  const BackButton = () => {
    return (
      <Button
        variant="transparent"
        size="standard"
        iconPosition="leading"
        icon={<IconArrowLeft />}
        onClick={handleBack}
      >
        {t('common.back', 'Back')}
      </Button>
    )
  }

  return (
    <>
      <Dialog
        id="share-listing-phone-dialog"
        title={t('l.listing.view.share_phone_modal.title', 'Invite Contacts')}
        open={open}
        onClose={onClose}
        actionButton={
          isMobile && (
            <Box style={{ width: 87 }}>
              <BackButton />
            </Box>
          )
        }
      >
        <Stack space="large">
          <Text size="standard">
            {t(
              'l.listing.view.share_phone_modal_description.text',
              'Invite potential renters by sharing your listing and connecting them with liv.rent. Enter their phone number below.'
            )}
          </Text>
          <Formik
            initialValues={{ phone: '' }}
            validationSchema={validationSchema}
            onSubmit={handleSend}
          >
            {({ values, isSubmitting, handleChange }) => (
              <StyledForm>
                <Stack space="large">
                  <Phone
                    name="phone"
                    placeholder={'Phone number'}
                    onChange={handleChange('phone')}
                    value={values.phone}
                    required={true}
                  />
                  <Box
                    display="flex"
                    flexDirection="row"
                    justifyContent="spaceBetween"
                    alignItems="center"
                  >
                    {!isMobile && (
                      <Box style={{ width: 87 }}>
                        <BackButton />
                      </Box>
                    )}

                    <Box style={{ width: isMobile ? '100%' : 147 }}>
                      <Button
                        type="submit"
                        name="submit"
                        variant="solid"
                        size="standard"
                        disabled={isSubmitting}
                      >
                        {t('l.listing.view.share_phone_modal_invite.button', 'Invite Renter')}
                      </Button>
                    </Box>
                  </Box>
                </Stack>
              </StyledForm>
            )}
          </Formik>
        </Stack>
      </Dialog>
    </>
  )
}

export default ShareByPhone
